import { Stack, Typography } from "@mui/material";
import { RateIndicator } from "../../../types/enums";
import { RateIndicatorIcon } from "../../ui/RateIndicatorIcon";
import { RoundedCircularProgress } from "../../ui";

type Props = {
  value: number;
  indicator?: RateIndicator;
  indicatorChange?: number;
  indicatorChangeAt?: string;
  isProduct?: boolean;
};

export const EngagementRate = ({
  value,
  indicator,
  indicatorChange,
  indicatorChangeAt,
  isProduct,
}: Props) => {
  const size = isProduct ? 100 : 156;

  return (
    <Stack
      sx={{ position: "relative", width: `${size}px`, height: `${size}px` }}
      justifyContent="center"
    >
      {indicator && !isProduct && (
        <Stack
          sx={{
            position: "absolute",
            left: 66,
            top: indicator === RateIndicator.up ? 36 : 98,
            zIndex: 5,
          }}
        >
          <RateIndicatorIcon
            indicatorRate={indicator}
            indicatorChange={indicatorChange}
            indicatorChangeAt={indicatorChangeAt}
          />
        </Stack>
      )}
      <RoundedCircularProgress
        size={size}
        thickness={6}
        variant="determinate"
        sx={{
          color: "#3279B3",
          position: "absolute",
          left: 0,
          top: 0,
          zIndex: 2,
          opacity: 1,
        }}
        value={value}
      />
      <RoundedCircularProgress
        size={size}
        thickness={6}
        variant="determinate"
        sx={{
          color: "#F7F7F7",
          position: "absolute",
          left: 0,
          top: 0,
          zIndex: 1,
        }}
        value={100}
      />
      <Typography
        variant="h3"
        align="center"
        sx={{
          flexShrink: 1,
          fontSize: isProduct ? "18px" : "32px",
          color: "#181818",
        }}
      >
        {value || 0}%
      </Typography>
    </Stack>
  );
};
